/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.validation.required\":[\"At least one selection is required.\"],\"checkbox-group.label.optional\":[\"Optional\"]}");
//# sourceMappingURL=messages.mjs.map